<template>
 <div class="reserve">
  <div class="reserve-title">拼团设置</div>
  <div class="com-content" :class="{'comContentMargin': creationMode}">
    <van-form 
      validate-first 
      input-align="right" 
      validate-trigger="onSubmit" 
      :show-error-message="false" 
      ref="form"
    >
      <van-field
        required
        v-model="form.groupWaitTime"
        label-width="9em"
        label="成团等待时间(小时)"
        type="digit"
        placeholder="请输入"
        :rules="[{ required: true, message: '请输入成团等待时间' }]"
        @blur="checkFeeValid('groupWaitTime')"
        :formatter="formatter"
      />
      <div class="tips">超过等待时间，成团自动失败</div>
       <van-field
        required
        label="核销方式"
        :rules="[{ required: true, message: '请选择核销方式' }]"
      >
        <template #input>
          <van-radio-group v-model="form.boolVerification " direction="horizontal" icon-size="16px" checked-color="#FF6B31">
            <van-radio name="true">自动核销</van-radio>
            <van-radio name="false">线下核销</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field name="switch" label="地理位置限制">
        <template #input>
          <van-radio-group v-model="form.boolAreaLimited" direction="horizontal" icon-size="16px" checked-color="#FF6B31">
            <van-radio name="false">关闭</van-radio>
            <van-radio name="true">开启</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <div class="tips">开启地理位置后，仅限分享门店所在市区才可进行拼团</div>
      <van-field name="switch" label-width="9em" label="限制内部人员参与">
        <template #input>
          <van-radio-group v-model="form.boolInternalStaffLimit" direction="horizontal" icon-size="16px" checked-color="#FF6B31">
            <van-radio name="false">关闭</van-radio>
            <van-radio name="true">开启</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <div class="tips">开启后内部职员将无法参与活动</div>
      <van-field
        v-model="form.activityBuyLimit"
        type="digit"
        label-width="9em"
        label="本场活动顾客限购"
        placeholder="请输入"
        @blur="checkFeeValid('activityBuyLimit')"
        :formatter="formatter"
      >
        <span slot="right-icon">次</span>
      </van-field>
      <van-field
        v-model="form.perGoodsBuyLimit"
        type="digit"
        label-width="9em"
        label="每件商品顾客限购"
        placeholder="请输入"
        @blur="checkFeeValid('perGoodsBuyLimit')"
        :formatter="formatter"
      >
        <span slot="right-icon">次</span>
      </van-field>
      <template v-if="form.goods.length">
        <div class="commodity-box" v-for="(item,index) in form.goods" :key="index">
          <div class="name">
            <span class="name-state" v-if="from == 'manager' && item.goodsName">
              {{item.status == 0 ? '使用中' : '已下架'}}
            </span>
            <span class="title">{{item.goodsName}}</span>
          </div>
          <div class="icon-box">
            <span class="del" @click="delGoods(item,index)">删除</span>
            <span v-if="from != 'manager'" @click="editGoods(item,index)">编辑</span>
            <span v-else @click="editGoods(item,index)">
                {{item.status == 0 ? '编辑并下架' : '编辑'}}
            </span>
          </div>
        </div>
      </template>
      <div class="add-goods-btn" @click="addGoods()">新增商品</div>
    </van-form>
  </div>
  <group-add-goods-pop  
    :defaultPhoneHeight="defaultPhoneHeight"
    :isAddGoods.sync="isAddGoods" 
    :goods="goods" 
    v-if="isAddGoods"
    @addGoodsSuccess="addGoodsSuccess" 
  />
 </div>
</template>

<script>
import groupAddGoodsPop from './group-add-goods-pop'
import { round2Places } from "@/utils/utils";
export default {
  props: {
    value:  {
      type: Object,
      default() {
        return {}
      }
    },
  },
  components: {
    groupAddGoodsPop
  },
  computed: {
    form: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('change',newVal)
      }
    },
    from() {
      return this.$route.query.from
    },
    // 组件创建方式
    creationMode() {
      return this.$route.query.creationMode != 'new' ? true : false
    }
  },
  data() {
    return {
      isAddGoods: false,
      defaultPhoneHeight: 0,
      selectField: '',
      boolAreaLimited: '',
      boolInternalStaffLimit: '',
      value1: '',
      value2: '',
      value3: '',
      goods: {},
      currentGoodsIndex: 0
    }
  },
  methods: {
    checkFeeValid(fieldName) {
      let fieldValue = this.form[fieldName]
      if (fieldValue > 9999999) {
        fieldValue= 9999999
      }
      this.form[fieldName] = round2Places(fieldValue)
    },
    formVerification() {
      let isAdopt = false
      const { groupWaitTime,activityBuyLimit,perGoodsBuyLimit} = this.form
      if (groupWaitTime == '') {
        this.$toast('请先选择成团等待时间')
      } else if (activityBuyLimit == '' && perGoodsBuyLimit == '') {
        isAdopt = true
      } else {
        if (Number(perGoodsBuyLimit) > Number(activityBuyLimit) ) {
          this.$toast('每件商品顾客限购次数小于等于本场活动顾客限购数')
        } else {
          isAdopt = true
        }
      }
      return isAdopt
    },
    addGoods() {
      if (!this.formVerification()) return
      this.goods= {
        activityId: this.form.activityId || '',
        groupId: this.form.groupId || '',
        groupWaitTime: this.form.groupWaitTime,
        boolAutoGroup: 'false',
        autoGroupTime: '',
        goodsName: '',
        oldPrice: '',
        singlePrice: '',
        teamNumber: '',
        groupBuyTitle: '拼团价',
        groupBuyPrice: '',
        goodsTag: '',
        headImg: '',
        goodsNumber: '',
        virtualPeople: '',
        headImgList:[],
        detailsImg: [],
      }
      this.isAddGoods = true
      this.currentGoodsIndex = this.form.goods.length
    },
    addGoodsSuccess(goods,save) {
      this.form.goods[this.currentGoodsIndex] = goods
      this.$emit('change', this.form)
      // 调接口保存 直接通知父组件改变数据
      if (save) {
        this.$emit('goodsHandler',this.currentGoodsIndex, goods)
      }
    },
    editGoods(goods,index) {
      this.currentGoodsIndex = index
      this.goods = {...goods,headImgList:[...goods.headImgList],detailsImg: [...goods.detailsImg] }
      this.goods.groupWaitTime = this.form.groupWaitTime
      if (this.from == 'manager') {
        // 使用中
        if (goods.status == 0) {
          this.$dialog.confirm({
            title: '确认提示',
            message:`下架后将无法选购本商品,待上架后才恢复,<br/>请问是否下架并编辑本商品？`,
          })
            .then(() => {
              this.editLower(goods,index)
            }).catch(()=>{})
        }else {
          this.isAddGoods = true
        }
        return
      }
      this.isAddGoods = true
    },
    editLower(goods) {
      const {activityId, goodsId} = goods
      this.$api.groupBuying.goodsOffline({activityId,goodsId}).then(res => {
        if (res.success) {
          this.isAddGoods = true
          goods.status = 1
          this.$emit('goodsHandler',this.currentGoodsIndex, goods)
        }
      })
    },
    delGoods(item,index) {
      this.$dialog.confirm({
        title: '删除确定',
        message:`商品删除后将无法恢复！<br/>请问是否删除商品？`,
      })
      .then(() => {
        if (this.from == 'manager') {
          const { activityId,goodsId} = item
          this.$api.groupBuying.deleteGoods({activityId,goodsId}).then(res => {
            if (res.success) {
              this.form.goods.splice(index, 1)
              this.$toast('删除成功')
              this.$emit('goodsHandler',index, {}, true)
            }
          })
        }else {
          this.form.goods.splice(index, 1)
          this.$toast('删除成功')
        }
      })
      .catch(_=>{})
    },
    submit() {
      return new Promise((resolve,reject) => {
        let isAdopt = this.formVerification()
        if (isAdopt) {
          this.$refs.form.validate().then(res => {
            if (!this.form.goods.length) {
              this.$toast('请新增商品')
              reject(false)
            }else {
              resolve(true)
            }
          }).catch(err => {
            this.$toast(err[0].message);
            reject(false)
          })
        }
      })
    },
    formatter(value) {
      if (value == 0 && value) {
        return 1
      }else {
        return value
      }
      
    },
  },
  created() {
    this.defaultPhoneHeight = window.innerHeight
  }
}
</script>

<style lang="stylus" scoped>
.reserve {
  margin: 15px 0;
  .reserve-title {
    padding: 15px 0 0 15px;
    font-size: 14px;
    font-weight: bold;
    color: #303133;
  }
  .com-content {
    // margin 10px 15px
    padding 4px
    background-color: #fff
    border-radius: 8px;
    .tips {
      padding: 10px 16px;
      font-size: 10px;
      color: #bbb;   
    }
    .commodity-box {
      display: flex;
      justify-content: space-between;
      margin: 15px;
      padding-bottom: 6px;
      border-bottom: 1px solid #ebedf0;
      .name {
        flex: 1;
        margin-right: 4px;
        display: flex;
        .name-state {
          font-size: 12px;
          color: #999;
          margin-right: 10px;
          margin-top: 2px;
        }
        .title {
          display: inline-block;
          // width: 100px;
           flex: 1;
        }
      }
      .icon-box {
        display: flex;
        align-items: center;
        color: #ff6b31;
        .add {
          margin-right: 10px;
        }
        .del {
          margin-right: 10px;
        }
      }
    }
    .add-goods-btn {
      margin 12px
      padding 6px 0
      text-align: center
      color $mainTextColor
      font-size 12px
      font-weight 600
      border 1px solid $mainTextColor
      border-radius 4px
    }
  }
  .comContentMargin {
    margin: 10px 15px;
  }
}
</style>